import { createSlice } from '@reduxjs/toolkit';
import { emptyInsurance } from 'constant/states';
// import { currencyFormat } from 'utils/helper';

export const mapInsuranceFromApi = (data) => {
  const navigation = data?.InsuranceNavigation ?? [];

  if (navigation.length) {
    return navigation.map((ins) => ({
      price: ins?.price ?? ins?.Price ?? '',
      currencyNameId: ins?.currencyNameId ?? ins?.CurrencyNameId ?? '',
    }));
  }

  return [];
};

export const ensurePieceClientIds = (pieces = []) =>
  pieces.map((piece, index) => ({
    ...piece,
    clientId:
      piece.clientId ??
      piece.id ??
      piece.RowUuid ??
      `piece-${index}-${Math.random().toString(36).slice(2, 9)}`,
  }));

export const syncInsuranceWithPieces = (insurance, piecesCount) => {
  const current = [...(insurance || [])];
  while (current.length < piecesCount) {
    current.push({ ...emptyInsurance });
  }
  return current.slice(0, piecesCount);
};

export const calculateTotalInsuranceAmount = (
  insurance = [],
  pieces = []
) => {
  const total = (insurance || []).reduce((sum, item, idx) => {
    const price = Number(item?.price || 0);
    if (!pieces?.length) {
      return sum + price;
    }

    const quantity = Number(pieces?.[idx]?.piece || 0);
    return sum + price * quantity;
  }, 0);

  return Number(total.toFixed(2));
};

const initialState = {
  shipmentInfo: {
    shipmentId: null, //update için dolu gelmeli
    solmazBillNumber: '',
    consignorCustomerId: '',
    consigneeAddressId: '',
    shipmentStatusId: 1,
    consignorReferance: '',
    serviceId: '',
    typeId: '',
    currencyId: '',
    currencyValue: 0,
    consignorAddressId: '',
    contents: '',
    readAgreement: false,
    consigneeAddress: null, //update için dolu gelmeli
    consignorCustomer: null, //update için dolu gelmeli
    consignorAddress: null, //update için dolu gelmeli
    shipmentPieces: [],
    isPickup: false,
    pickupDate: null,
    eori: '',
    deliveryOrderNotes: '',
    insurance: [],
    ioss: '',
    containerTypeId: '',
    editable: false,
  },
  isRequiredContainer: false,
  isDOC: false,
};

export const shipmentSlice = createSlice({
  name: 'shipmentCreate',
  initialState,
  reducers: {
    updateShipmentInfo: (state, action) => {
      state.shipmentInfo = action.payload;
    },
    updateIsRequiredContainer: (state, action) => {
      state.isRequiredContainer = action.payload;
    },
    updateShipmentInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.shipmentInfo[field] = value;
    },
    updateShipmentInsuranceInfoField: (state, action) => {
      const { idx, field, value } = action.payload;
      if (!state.shipmentInfo.insurance[idx]) {
        state.shipmentInfo.insurance[idx] = { ...emptyInsurance };
      }
      state.shipmentInfo.insurance[idx][field] = value;
    },
    addShipmentPiece: (state, action) => {
      const piece = {
        ...action.payload,
        clientId:
          action.payload.clientId ||
          `piece-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      };
      state.shipmentInfo.shipmentPieces = [
        ...state.shipmentInfo.shipmentPieces,
        piece,
      ];
      // Parça yokken sigorta açılırsa zaten 1 kayıt oluşur; push yerine
      // uzunluğu parça sayısına eşitle (çift sigorta kaydını önler).
      state.shipmentInfo.insurance = syncInsuranceWithPieces(
        state.shipmentInfo.insurance,
        state.shipmentInfo.shipmentPieces.length
      );
    },
    addProductOfPiece: (state, action) => {
      const { idx, product } = action.payload;
      state.shipmentInfo.shipmentPieces[idx].pieceOfProducts = [
        ...state.shipmentInfo.shipmentPieces[idx].pieceOfProducts,
        product,
      ];
    },
    clearShipmentSlice: (state) => {
      state.shipmentInfo = initialState.shipmentInfo;
    },
    updateShipmentPiece: (state, action) => {
      const { field, value, idx } = action.payload;
      state.shipmentInfo.shipmentPieces[idx][field] = value;
    },
    updateShipmentProductOfPiece: (state, action) => {
      const { field, value, indexOfProduct, indexOfPiece } = action.payload;
      state.shipmentInfo.shipmentPieces[indexOfPiece].pieceOfProducts[
        indexOfProduct
      ][field] = value;
    },
    removeShipmentPiece: (state, action) => {
      const { idx } = action.payload;
      state.shipmentInfo.shipmentPieces =
        state.shipmentInfo.shipmentPieces.filter((item, indx) => indx !== idx);
      state.shipmentInfo.insurance = state.shipmentInfo.insurance.filter(
        (_, indx) => indx !== idx
      );
    },
    removeShipmentProductOfPiece: (state, action) => {
      const { indexOfProduct, indexOfPiece } = action.payload;
      state.shipmentInfo.shipmentPieces[indexOfPiece].pieceOfProducts =
        state.shipmentInfo.shipmentPieces[indexOfPiece].pieceOfProducts.filter(
          (item, indx) => indx !== indexOfProduct
        );
    },
    updateIsDOC: (state, action) => {
      state.isDOC = action.payload;
    },
  },
});

export const shipmentInfoSelector = (state) =>
  state.shipmentCreate.shipmentInfo;

export const shipmentPieceErrorSelector = (state) =>
  state.shipmentCreate.shipmentInfo.shipmentPieces?.map((piece) => {
    const { isDOC } = state.shipmentCreate;
    return {
      piece: piece.piece || isDOC ? '' : 'Paket adeti giriniz',
      weight: piece.weight || isDOC ? '' : 'Ağırlık değeri giriniz',
      length: piece.length || isDOC ? '' : 'Uzunluk değeri giriniz',
      width: piece.width || isDOC ? '' : 'Genişlik değeri giriniz',
      height: piece.height || isDOC ? '' : 'Yükseklik değeri giriniz',
      containerTypeId: state.shipmentCreate.isRequiredContainer
        ? piece.containerTypeId
          ? ''
          : 'Kap Türü seçiniz'
        : '',
    };
  });
export const productOfPieceErrorSelector = (state) =>
  state.shipmentCreate.shipmentInfo.shipmentPieces?.map((piece) =>
    piece?.pieceOfProducts?.map((product) => {
      const { isDOC } = state.shipmentCreate;

      return {
        description: product.description ? '' : 'İç ürün açıklaması giriniz',
        gtip:
          (product.gtip ? '' : isDOC ? '' : 'Gtip değeri giriniz') ||
          (product.gtip && product.gtip.toString().length < 4
            ? 'Gtip değeri en az 4 haneli olmalıdır'
            : ''),
        amount: product.amount || isDOC ? '' : 'İç ürün adedi giriniz',
        price: product.price ? '' : 'İç ürün değeri giriniz',
      };
    })
  );

export const shipmentTotalWeightSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (prr, crr) => prr + +crr.priceableWeight * +crr.piece,
    0
  );

export const shipmentTotalPieceSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (prr, crr) => prr + +crr.piece,
    0
  );

export const shipmentTotalVolumeSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (prr, crr) => prr + +crr.volume * +crr.piece,
    0
  );

export const shipmentTotalVolumetricWeightSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (prr, crr) => prr + +crr.volumetricWeight * +crr.piece,
    0
  );

export const shipmentTotalRealWeightSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (prr, crr) => prr + +crr.weight * +crr.piece,
    0
  );

export const shipmentTotalCurrencyValueSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (prr, crr) => prr + +crr.currencyValue * (+crr.piece || 0),
    0
  );

export const shipmentTotalProductPieceSelector = (state) =>
  state.shipmentCreate.shipmentInfo?.shipmentPieces?.reduce(
    (allTotal, piece) => {
      const pieceCount = +piece.piece || 0;
      const productAmountSum = (piece.pieceOfProducts || []).reduce(
        (total, record) => total + (+record.amount || 0),
        0
      );
      return allTotal + productAmountSum * pieceCount;
    },
    0
  );

export const {
  updateShipmentInfo,
  updateShipmentInfoField,
  updateIsRequiredContainer,
  addShipmentPiece,
  addProductOfPiece,
  updateShipmentPiece,
  clearShipmentSlice,
  removeShipmentPiece,
  updateShipmentInsuranceInfoField,
  updateShipmentProductOfPiece,
  removeShipmentProductOfPiece,
  updateIsDOC,
} = shipmentSlice.actions;

export const shipmentCreateReducer = shipmentSlice.reducer;
export const shipmentCreateReducerName = shipmentSlice.name;

export default shipmentSlice.reducer;
